import React, { useEffect, useState } from "react";
import "./PosterView.css";
import { createPortal } from "react-dom";
// import emiposter from "../../Assets/offfer/emiposter.jpeg";
// import emiposter2 from "../../Assets/offfer/poster2.jpeg";
// import emiposter3 from "../../Assets/offfer/of3.jpeg";

const STATIC_POSTER = [
  // {
  //   _id: "static-poster3",
  //   poster: emiposter3,
  //   title: "Featured3",
  // },
  // {
  //   _id: "static-poster2",
  //   poster: emiposter2,
  //   title: "Featured2",
  // },
  // {
  //   _id: "static-poster",
  //   poster: emiposter,
  //   title: "Featured",
  // },
];

const PosterView = ({ offersData }) => {
  // const posterOffers = offersData?.filter(
  //   (offer) => offer.poster && offer.poster.trim() !== "",
  // );

  // ----------new code for static poster added to the list of offers

  const realOffers = offersData?.filter(
    (offer) => offer.poster && offer.poster.trim() !== "",
  );
  const posterOffers = [...STATIC_POSTER, ...(realOffers || [])];

  // ---------------

  const [activeIndex, setActiveIndex] = useState(null);
  const [showWelcomePopup, setShowWelcomePopup] = useState(false);
  useEffect(() => {
    const seen = sessionStorage.getItem("welcomePopup");

    // console.log(seen, "seen2")
    if (!seen) {
      console.log(seen, "seen");
      setShowWelcomePopup(true);
      sessionStorage.setItem("welcomePopup", "true");
    }
  }, []);

  const nextImage = () => {
    setActiveIndex((prev) => (prev + 1) % posterOffers.length);
  };

  const prevImage = () => {
    setActiveIndex(
      (prev) => (prev - 1 + posterOffers.length) % posterOffers.length,
    );
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (activeIndex === null) return;

      if (e.key === "Escape") setActiveIndex(null);
      if (e.key === "ArrowRight") nextImage();
      if (e.key === "ArrowLeft") prevImage();
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [activeIndex]);
  return (
    <>
      <div className="poster-view">
        {posterOffers?.map((item, index) => (
          <div key={item._id} onClick={() => setActiveIndex(index)}>
            <img src={item.poster} alt={item.title} />
          </div>
        ))}
      </div>

      {showWelcomePopup &&
        createPortal(
          <div
            className="welcome-popup-overlay"
            onClick={() => setShowWelcomePopup(false)}
          >
            <div className="welcome-popup" onClick={(e) => e.stopPropagation()}>
              <button
                className="welcome-popup-close"
                onClick={() => setShowWelcomePopup(false)}
              >
                ✕
              </button>

              <img src={posterOffers?.[0]?.poster} alt="Welcome" />
            </div>
          </div>,
          document.body,
        )}
      {activeIndex !== null &&
        posterOffers?.length > 0 &&
        createPortal(
          <div className="lightbox" onClick={() => setActiveIndex(null)}>
            <div
              className="lightbox-content"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className="lightbox-close"
                onClick={() => setActiveIndex(null)}
              >
                ✕
              </button>

              <button className="lightbox-prev" onClick={prevImage}>
                ❮
              </button>

              <img
                src={posterOffers[activeIndex].poster}
                alt={posterOffers[activeIndex].title}
              />

              <button className="lightbox-next" onClick={nextImage}>
                ❯
              </button>
            </div>
          </div>,
          document.body,
        )}
    </>
  );
};

export default PosterView;
